const getLabelSum = (data, sumTopLabel) => param => {
  return typeof sumTopLabel === "function" ? sumTopLabel(data[param.dataIndex]) : 0;
};

export const getBarOptions = (
  name,
  data,
  axisMapper,
  valueMapper,
  { color = "blue", rotate = 30, showAxisY = false, unit = "", barWidth = 15 } = {}
) => {
  return {
    tooltip: {
      trigger: "axis"
    },
    calculable: true,
    xAxis: [
      {
        type: "category",
        data: data.map(axisMapper),
        axisLabel: {
          rotate,
          color: "#595959",
          fontSize: 11
        }
      }
    ],
    yAxis: [
      {
        type: "value",
        show: showAxisY,
        axisLabel: {
          color: "#595959"
        }
      }
    ],
    series: [
      {
        name,
        type: "bar",
        barWidth,
        data: data.map(valueMapper),
        itemStyle: {
          normal: {
            color,
            label: {
              show: true,
              position: "top",
              fontSize: 10,
              formatter: `{c} ${unit}`
            }
          }
        }
      }
    ]
  };
};

export const getBarOptionsMultiple = (
  data,
  axisMapper,
  dataMappers,
  colors,
  { rotate = 30, showAxisY = false, showLegend = true, unit = "", barWidth = 10, stack, sumTopLabel } = {}
) => {
  return {
    color: colors,
    tooltip: {
      trigger: "axis"
    },
    legend: showLegend ? { data: dataMappers.map(e => e.name) } : undefined,
    calculable: true,
    xAxis: [
      {
        type: "category",
        data: data.map(axisMapper),
        axisLabel: {
          rotate,
          color: "#595959",
          fontSize: 11
        }
      }
    ],
    yAxis: [
      {
        type: "value",
        show: showAxisY,
        axisLabel: {
          color: "#595959",
          fontSize: 11
        }
      }
    ],
    series: dataMappers.map(({ name, mapper }, index) => ({
      name,
      type: "bar",
      barWidth,
      stack,
      data: data.map(mapper),
      itemStyle: stack
        ? {
            normal: {
              label: {
                show: index === dataMappers.length - 1, // show total label only on top most stack
                color: "black",
                fontSize: 10,
                position: "top",
                formatter: sumTopLabel ? getLabelSum(data, sumTopLabel) : undefined
              }
            }
          }
        : {
            normal: {
              label: {
                show: true,
                fontSize: 10,
                position: "top",
                formatter: `{c} ${unit}`
              }
            }
          }
    }))
  };
};

export const getPieOptions = (name, data, legendMapper, valueMapper, colors, center = ["50%", "50%"]) => {
  return {
    color: colors,
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)"
    },
    legend: {
      x: "center",
      y: "bottom",
      data: data.map(legendMapper),
      textStyle: {
        color: "#595959",
        fontSize: 11
      }
    },
    calculable: true,
    series: [
      {
        name,
        type: "pie",
        radius: ["45%", "55%"],
        center,
        avoidLabelOverlap: false,
        data: data.map(valueMapper),
        itemStyle: {
          normal: {
            label: {
              position: "outer",
              formatter: function (params) {
                return params.percent + "%";
              },
              fontSize: 11
            },
            labelLine: {
              show: false
            }
          },
          emphasis: {
            label: {
              show: true,
              formatter: "{b}\n{d}%"
            }
          }
        }
      }
    ]
  };
};

export const getLineOptions = (
  data,
  axisMapper,
  dataMappers,
  colors,
  { rotate = 30, smooth = false, area = false, stack } = {}
) => {
  return {
    color: colors,
    tooltip: {
      trigger: "axis"
    },
    legend: {
      data: dataMappers.map(e => e.name)
    },
    xAxis: {
      type: "category",
      data: data.map(axisMapper),
      axisLabel: {
        rotate,
        color: "#595959",
        fontSize: 11
      }
    },
    yAxis: {
      type: "value",
      axisLabel: {
        color: "#595959",
        fontSize: 11
      }
    },
    series: dataMappers.map(({ name, mapper }) => ({
      name,
      type: "line",
      stack,
      smooth,
      areaStyle: area ? {} : undefined,
      data: data.map(mapper)
    }))
  };
};
